var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.3 15.8",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount",
    transform: "translate(-10.359 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(10.359 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M14.4,8.2c-0.1-0.1-0.1-0.3,0-0.4L15,6.6c0.3-0.7,0.1-1.5-0.6-1.8l-1.2-0.6C13.1,4.1,13,4,13,3.8l-0.2-1.3 c-0.1-0.7-0.8-1.2-1.5-1.1L10,1.6c-0.1,0-0.3,0-0.4-0.1l-1-0.9C8,0,7.2,0,6.6,0.5l-1,0.9c0,0.1-0.2,0.2-0.3,0.2L4,1.4 C3.2,1.3,2.5,1.8,2.4,2.5L2.2,3.8c0,0.1-0.1,0.3-0.2,0.3L0.8,4.8C0.1,5.1-0.1,5.9,0.2,6.6l0.6,1.2c0.1,0.1,0.1,0.3,0,0.4L0.2,9.4 c-0.3,0.7-0.1,1.5,0.6,1.8L2,11.8c0.1,0.1,0.2,0.2,0.2,0.3l0.2,1.3c0.1,0.7,0.7,1.1,1.3,1.1c0.1,0,0.1,0,0.2,0l1.3-0.2 c0.1,0,0.3,0,0.4,0.1l1,0.9c0.5,0.5,1.4,0.5,1.9,0l1-0.9c0.1-0.1,0.2-0.1,0.4-0.1l1.3,0.2c0.7,0.1,1.4-0.4,1.5-1.1l0.2-1.3 c0-0.1,0.1-0.3,0.2-0.3l1.2-0.6c0.7-0.3,0.9-1.1,0.6-1.8L14.4,8.2z M5.8,3.9c0.9,0,1.7,0.7,1.7,1.7S6.7,7.2,5.8,7.2 S4.1,6.5,4.1,5.6C4.1,4.6,4.9,3.9,5.8,3.9z M4.9,11.3c-0.2,0.2-0.5,0.2-0.6,0s-0.2-0.5,0-0.6l6-6c0.2-0.2,0.5-0.2,0.6,0 c0.2,0.2,0.2,0.5,0,0.6L4.9,11.3z M9.4,12.1c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7 C11.1,11.3,10.3,12.1,9.4,12.1L9.4,12.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    transform: "translate(17.727 8.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M2,1.5c-0.4,0-0.8,0.3-0.8,0.8S1.6,3,2,3s0.8-0.3,0.8-0.8C2.8,1.8,2.4,1.5,2,1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    transform: "translate(14.62 4.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M1.5,0.8c-0.4,0-0.8,0.3-0.8,0.8C0.8,2,1.1,2.3,1.5,2.3S2.3,2,2.3,1.5C2.3,1.1,1.9,0.8,1.5,0.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.e522fc3b.svg";
export { ForwardRef as ReactComponent };